module.exports = "/_next/static/images/9b382a348b2d73f62a706980ad2f6b83-gaby-meza.png.webp";